import React from 'react';
import { Smile } from 'react-feather';
import i18next from 'i18next';

import CollapsibleCard from 'app/components/common/CollapsibleCard';
import GetDeviceReady from 'app/components/welcome/GetDeviceReady';
import HowToGetMoreOrders from 'app/components/welcome/HowToGetMoreOrders';
import ReservationLinks from 'app/components/welcome/ReservationLinks';
import EnhancedOrdersList from './OrdersListPage';
import type { PageComponent } from 'app/types-global';
import { useAppSelector } from 'hooks/useRedux';
import { selectRestaurant } from 'store/restaurant';

const WelcomePage: PageComponent<{}> = () => {
  const restaurant = useAppSelector(selectRestaurant)
  if (!restaurant) {
    return null;
  }

  return (
    <>
      <h1 className="h3">{i18next.t('welcome-page.greeting')}</h1>
      <div className="h5 w-100 text-left" style={{ maxWidth: 550 }}>
        <p>
          {i18next.t('welcome-page.intro')}{' '}
          <Smile />)
        </p>
      </div>
      <h4>{i18next.t('welcome-page.important-sections')}</h4>
      <ul>
        <li>
          <a href={EnhancedOrdersList.url}>{i18next.t(`nav.${EnhancedOrdersList.navName}`)}</a>
        </li>
        <li>
          <a href="/settings/orders">
            {i18next.t('welcome-page.order-settings-link')}
          </a>
        </li>
        <li>
          <a href="/menu">{i18next.t('welcome-page.menu-edit-link')}</a>
        </li>
      </ul>
      <CollapsibleCard
        title={
          <>
            <Smile /> {i18next.t('welcome-page.step-1-title')}
          </>
        }
      >
        <ul>
          <li>{i18next.t('welcome-page.step-1-item-1')}</li>
          <li>{i18next.t('welcome-page.step-1-item-2')}</li>
        </ul>
      </CollapsibleCard>
      <GetDeviceReady />
      <HowToGetMoreOrders restaurant={restaurant} />
      <ReservationLinks restaurant={restaurant} />
    </>
  );
};

WelcomePage.navName = 'Pierwsze kroki';
WelcomePage.url = '/how-to-setup';

export default WelcomePage;
